export var getInitialCharacterCount = function getInitialCharacterCount(_ref) {
  var defaultValue = _ref.defaultValue,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value;
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (value && typeof value === 'string') return value.length;

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (defaultValue && typeof defaultValue === 'string') return defaultValue.length;
  return 0;
};